var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.type === 'logo_headline_custom' && _vm.main_logo)?_c('div',{staticClass:"logo"},[_c('img',{attrs:{"alt":_vm.main_logo.alt,"src":_vm.main_logo.url}})]):_c('div',{staticClass:"logo",domProps:{"innerHTML":_vm._s(_vm.logo)}})
}
var staticRenderFns = []

export { render, staticRenderFns }